import Loading from "components/Loading";
import React from "react";

type Props = {
  imageUrl: string;
};

export default function ImageViewer(props: Props) {
  const { imageUrl } = props;

  if (!imageUrl) return <Loading />;

  return (
    <img
      alt="Imagem recebida"
      style={{ width: "100%", maxWidth: "250px", height: "auto", cursor: 'pointer' }}
      src={imageUrl}
    />
  );
}
